var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 17 0 17 19.405691 0 19.405691"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Dashboard--Profile-dropdown",
    transform: "translate(-1290.000000, -81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1269.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_profile",
    transform: "translate(21.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,1.77123928 C10.465649,1.77123928 12.0649161,3.37050641 12.0649161,5.3361554 C12.0649161,7.30180438 10.465649,8.90107152 8.5,8.90107152 C6.53435101,8.90107152 4.93508388,7.30180438 4.93508388,5.3361554 C4.93508388,3.37050641 6.53435101,1.77123928 8.5,1.77123928 M12.3489285,9.02270675 C13.2676878,8.06350075 13.836303,6.76595985 13.836303,5.3361554 C13.836303,2.39358654 11.4422736,-0.000147615574 8.5,-0.000147615574 C5.55772637,-0.000147615574 3.16369699,2.39358654 3.16369699,5.3361554 C3.16369699,6.76595985 3.73231218,8.06350075 4.65107152,9.02270675 C1.99930534,9.57183669 0,11.9251242 0,14.7372009 L0,18.5199976 C0,19.0094908 0.396495433,19.405691 0.885693446,19.405691 C1.37489146,19.405691 1.77138689,19.0094908 1.77138689,18.5199976 L1.77138689,14.7372009 C1.77138689,12.495806 3.5950297,10.6724584 5.83642458,10.6724584 L11.1635754,10.6724584 C13.4049703,10.6724584 15.2286131,12.495806 15.2286131,14.7372009 L15.2286131,16.3899048 C15.2286131,17.076022 14.6700358,17.6343041 13.9836234,17.6343041 L4.04939043,17.6343041 C3.56048765,17.6343041 3.16369699,18.0307996 3.16369699,18.5199976 C3.16369699,19.0094908 3.56048765,19.405691 4.04939043,19.405691 L13.9836234,19.405691 C15.6469556,19.405691 17,18.0526467 17,16.3899048 L17,14.7372009 C17,11.9251242 15.0006947,9.57183669 12.3489285,9.02270675",
    id: "Fill-1",
    fill: "#132044",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.b878c50dfe7ce3399df55bed0f20e7e8.svg";
export { ForwardRef as ReactComponent };